export interface IAloDriftConstParam {
    yoGpsLat:number|null
    yoGpsLon:number|null
    yoGpsDatTime:string
}

export class AloDrift {
    
    public yoGpsLat:number|null
    public yoGpsLon:number|null   
    public yoGpsDatTime:Date

    constructor({yoGpsLat,yoGpsLon,yoGpsDatTime}:IAloDriftConstParam = {} as IAloDriftConstParam) {
        this.yoGpsLat = yoGpsLat
        this.yoGpsLon = yoGpsLon        
        this.yoGpsDatTime = new Date(yoGpsDatTime)
    }
}